const asyncSleep = (waitTime: number) => new Promise(resolve => setTimeout(resolve, waitTime));

export default asyncSleep;
